import { MinimalPrice, ValueForMoneyScoresFull, ValueForMoneyScores } from '@webtypes/goApi';

import { apiGet } from '@lib/api/apiClient';
import generateQueryUrl from 'vivino-js/generateQueryUrl';

export const getVintageValueForMoneyScores = (
  vintageId: number,
  priceId: number
): Promise<{ qpr_scores: ValueForMoneyScoresFull }> => {
  const url = generateQueryUrl({
    baseUrl: `/api/vintages/${vintageId}/value_for_money`,
    params: [{ name: 'price_id', value: priceId }],
  });

  return apiGet({ url });
};

export const fetchMinimalPrice = ({
  vintageId,
  currencyCode,
  unitBottleQuantity,
  bottleSize,
  merchantId,
}: {
  vintageId: number;
  currencyCode: string;
  unitBottleQuantity?: number;
  bottleSize?: number;
  merchantId?: number;
}): Promise<{ minimal_price: MinimalPrice }> => {
  const url = generateQueryUrl({
    baseUrl: `/api/vintages/${vintageId}/minimal_price`,
    params: [
      {
        name: 'currency_code',
        value: currencyCode,
      },
      {
        name: 'unit_bottle_quantity',
        value: unitBottleQuantity,
      },
      {
        name: 'bottle_size',
        value: bottleSize,
      },
      {
        name: 'merchant_id',
        value: merchantId,
      },
    ],
  });

  return apiGet({ url });
};

export const getValueForMoneyScores = ({
  vintageId,
  price,
  bottleVolume,
  bottleUnitCount,
  countryCode,
  merchantId,
  volumeDiscount,
}: {
  vintageId: number;
  price: number;
  bottleVolume: number;
  bottleUnitCount: number;
  countryCode: string;
  merchantId: number;
  volumeDiscount?: number;
}): Promise<{ scores: ValueForMoneyScores }> => {
  const url = generateQueryUrl({
    baseUrl: `/api/vintages/${vintageId}/value_for_money_scores`,
    params: [
      { name: 'price', value: price },
      { name: 'bottle_size_milliliters', value: bottleVolume },
      { name: 'unit_count', value: bottleUnitCount },
      { name: 'country_code', value: countryCode },
      { name: 'merchant_id', value: merchantId },
      { name: 'volume_discount', value: volumeDiscount },
    ],
  });

  return apiGet({ url });
};
